module.exports = __webpack_public_path__ + "media/images/landing/browser_perspective.en-2ccde44699e4e5f95a806724c2264a08.png";